import { render, staticRenderFns } from "./DevicesUnusedTable.vue?vue&type=template&id=505238b5&scoped=true&"
import script from "./DevicesUnusedTable.vue?vue&type=script&lang=js&"
export * from "./DevicesUnusedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505238b5",
  null
  
)

export default component.exports